'use strict'

const KEYWORDS = new Set(`
const let var function return if else for while do switch case break continue
new try catch finally throw typeof instanceof class extends import export default
from async await of in true false null undefined this
`.trim().split(/\s+/))

const COLORS = {
  k: 'color:#c6ee7a',
  s: 'color:#e6c07b',
  c: 'color:#7d9a78;font-style:italic',
  n: 'color:#d19a66'
}

function escapeHtml (text) {

  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
}

function isIdentStart (ch) {

  return /[A-Za-z_$]/.test(ch)
}

function isIdent (ch) {

  return /[A-Za-z0-9_$]/.test(ch)
}

function span (kind, text) {

  return `<span style="${COLORS[kind]}">${escapeHtml(text)}</span>`
}

function highlightJavaScript (code) {

  const source = String(code || '')
  let html = ''
  let i = 0

  while (i < source.length) {

    const ch = source[i]
    const next = source[i + 1]

    if (ch === '/' && next === '/') {

      const start = i

      i += 2

      while (i < source.length && source[i] !== '\n') i += 1

      html += span('c', source.slice(start, i))
      continue
    }

    if (ch === '/' && next === '*') {

      const start = i

      i += 2

      while (i < source.length && !(source[i] === '*' && source[i + 1] === '/')) i += 1

      if (i < source.length) i += 2

      html += span('c', source.slice(start, i))
      continue
    }

    if (ch === '"' || ch === "'" || ch === '`') {

      const quote = ch
      const start = i

      i += 1

      while (i < source.length) {

        if (source[i] === '\\') {

          i += 2
          continue
        }

        if (source[i] === quote) {

          i += 1
          break
        }

        if (quote !== '`' && source[i] === '\n') break

        i += 1
      }

      html += span('s', source.slice(start, i))
      continue
    }

    if (ch >= '0' && ch <= '9') {

      const start = i

      i += 1

      while (i < source.length && /[0-9a-fA-FxX._]/.test(source[i])) i += 1

      html += span('n', source.slice(start, i))
      continue
    }

    if (isIdentStart(ch)) {

      const start = i

      i += 1

      while (i < source.length && isIdent(source[i])) i += 1

      const word = source.slice(start, i)

      html += KEYWORDS.has(word) ? span('k', word) : escapeHtml(word)
      continue
    }

    html += escapeHtml(ch)
    i += 1
  }

  return html
}

module.exports = { highlightJavaScript }
